// extracted by mini-css-extract-plugin
export default {"container":"TeaPath_container__Bg+WW","navigation":"TeaPath_navigation__hti+z","navigationItem":"TeaPath_navigationItem__EUUhG"};